import favoriteApi from '@/api/favorites'
const types = {
  SET_FAVORITE_LIST: 'favorite/SET_FAVORITE_LIST'
}
const state = {
  favoriteList: []
}
const actions = {
  getFavoriteListData ({ commit }, payload) {
    favoriteApi.getFavoriteListData(payload.userId, payload.purchaseType).then(res => {
      let favoriteList = res.data.data.sort((a, b) => b.id - a.id)
      commit(types.SET_FAVORITE_LIST, { favoriteList: favoriteList })
    })
  }
}
const mutations = {
  [types.SET_FAVORITE_LIST] (state, payload) {
    state.favoriteList = payload.favoriteList
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
